import { render } from "./CreateException.vue?vue&type=template&id=cd91881e&scoped=true"
import script from "./CreateException.vue?vue&type=script&lang=js"
export * from "./CreateException.vue?vue&type=script&lang=js"

import "./CreateException.vue?vue&type=style&index=0&id=cd91881e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd91881e"]])

export default __exports__